import { render, staticRenderFns } from "./YTChannel.vue?vue&type=template&id=e0ad21a8&"
import script from "./YTChannel.vue?vue&type=script&lang=js&"
export * from "./YTChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports